export default function NvwButton(props) {
	return (
		<a
			href={props?.href ?? "#"}
			className={`inline-block rounded-full px-8 py-3 bg-clear border-fog border-2 font-pastiche text-obsidian text-base text-center font-${
				props?.fontWeight ?? "normal"
			} ${props?.isBlock ? "w-full" : ""} ${props.className ?? ""}`}
			onClick={props?.onClick || null}
		>
			{props?.children}
		</a>
	);
}
